"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FuseSharedModule {
}
exports.FuseSharedModule = FuseSharedModule;
